<template>
  <b-navbar wrapper-class="container" :transparent="true" spaced :centered="false" :class="['nav', { 'scrolled': isScrolled }]">
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img :src="require('@/assets/logo.png')" class="navbar-logo" alt="LAZ-BOY" />
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item class="me-10" tag="router-link" to="/"> HOME </b-navbar-item>
      <b-navbar-item class="me-10" tag="router-link" :to="{ path: '/concept' }">
        CONCEPT
      </b-navbar-item>
      <b-navbar-item class="me-10" tag="router-link" :to="{ path: '/products' }">
        PRODUCT
      </b-navbar-item>
      <b-navbar-dropdown label="TRAINING" hoverable>
        <b-navbar-item tag="router-link" :to="{ path: '/training' }">
          TRAINING 2022
        </b-navbar-item>
      </b-navbar-dropdown>
      <template slot="end" wrapper-class="d-none"></template>
      <!-- 
      <b-navbar-item
        v-if="!loggedIn()"
        tag="router-link"
        :to="{ path: '/register' }"
      >
        REGISTER
      </b-navbar-item>
      <b-navbar-item
        v-if="!loggedIn()"
        tag="router-link"
        :to="{ path: '/login' }"
      >
        LOGIN
      </b-navbar-item>
      <Button
        label="LOGOUT"
        width="10px"
        :no-padding="true"
        class="px-12"
        @click="onLogout"
        v-if="loggedIn()"
      /> -->
    </template>
  </b-navbar>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      name: "User",
      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    ...mapActions({
      logout: "user/logout",
    }),
    loggedIn() {
      return this.token != null;
    },
    onLogout() {
      this.token = null;
      this.logout();
      this.$router.replace("/");
    },
  },
  computed: {
    ...mapState({
      token: (state) => state.token,
      email: (state) => state.user.email,
    }),
  },
};
</script>
<style lang="scss" scoped>
.nav {
  position: sticky;
  top: 0;
  z-index: 1000;
  transition: background-color 0.3s ease;
}
.nav.scrolled {
  background: #e5e5e5;
}
.navbar a.navbar-item {
  color: #6da6b5;
  font-weight: 500;
}
.navbar .navbar-link {
  color: #6da6b5;
  font-weight: 500;
}
.navbar .navbar-dropdown .navbar-item {
  color: #6da6b5;
  font-weight: 500;
}
.v-application a {
  color: #6da6b5;
  &.router-link-exact-active {
    color: #003349;
  }
}

.training-sub-menu {
  background: #dfdfdf;
  cursor: pointer;
}
.training-sub-menu:hover {
  background: white;
}
</style>